import React from 'react';
import { DatePicker, Select } from 'antd';
import { LuCalendarDays } from 'react-icons/lu';

const FilterBar = ({
  onDateChange,
  onOrgChange,
  onCampaignChange,
  onFormChange,
  organizations = [],
  campaigns = [],
  forms = [],
  hide,
  isInterpreter,
  isLoading,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="w-full md:w-[calc((100%-2.25rem)/4)]">
        <DatePicker.RangePicker
          allowClear
          allowEmpty={[true, true]}
          placeholder={['From', 'To']}
          suffixIcon={<LuCalendarDays className="text-gray-400" size={20} />}
          className="h-12 w-full rounded-2xl border border-gray-200 px-4 [&_.ant-picker-input>input]:text-xs md:[&_.ant-picker-input>input]:text-sm [&_.ant-picker-input]:flex [&_.ant-picker-input]:items-center [&_.ant-picker-separator]:flex [&_.ant-picker-separator]:items-center"
          onChange={onDateChange}
          format="YYYY-MM-DD"
          separator={<span className="inline-flex items-center text-gray-400">-</span>}
          popupClassName="date-range-popup-mobile"
          disabled={isLoading ? [true, true] : false}
          getPopupContainer={() => document.body}
          dropdownAlign={{
            points: ['tl', 'bl'],
            offset: [0, 4],
            overflow: {
              adjustX: 1,
              adjustY: 1,
            },
          }}
          style={{ width: '100%' }}
        />
      </div>

      {hide !== 'organization' && (
        <Select
          allowClear
          placeholder="Organisation"
          className="h-12 w-full md:w-[calc((100%-2.25rem)/4)] rounded-full multi-select"
          onChange={onOrgChange}
          options={organizations.map(org => ({
            value: org._id,
            label: org.name
          }))}
          mode="multiple"
          maxTagCount={2}
          maxTagTextLength={5}
          popupMatchSelectWidth={false}
          disabled={isLoading}
          getPopupContainer={() => document.body}
        />
      )}

      {!isInterpreter && (
        <Select
          allowClear
          placeholder="Campaign"
          className="h-12 w-full md:w-[calc((100%-2.25rem)/4)] rounded-full multi-select"
          onChange={onCampaignChange}
          options={campaigns.map(campaign => ({
            value: campaign._id,
            label: campaign.title
          }))}
          mode="multiple"
          maxTagCount={2}
          maxTagTextLength={5}
          popupMatchSelectWidth={false}
          disabled={isLoading}
          getPopupContainer={() => document.body}
        />
      )}

      {!isInterpreter && (
        <Select
          allowClear
          placeholder="Form"
          className="h-12 w-full md:w-[calc((100%-2.25rem)/4)] rounded-full multi-select"
          onChange={onFormChange}
          options={forms.map(form => ({
            value: form._id,
            label: form.title
          }))}
          mode="multiple"
          maxTagCount={2}
          maxTagTextLength={5}
          popupMatchSelectWidth={false}
          disabled={isLoading}
          getPopupContainer={() => document.body}
        />
      )}
    </div>
  );
};

export default FilterBar;
